import { render, staticRenderFns } from "./blogAd.vue?vue&type=template&id=a5c32da6&scoped=true&lang=html&"
import script from "./blogAd.vue?vue&type=script&lang=js&"
export * from "./blogAd.vue?vue&type=script&lang=js&"
import style0 from "./blogAd.vue?vue&type=style&index=0&id=a5c32da6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5c32da6",
  null
  
)

export default component.exports